module.exports = __webpack_public_path__ + "img/colour-charcoal.27397bf4.png";